module.exports = __webpack_public_path__ + "img/low-resolution.806b88b5.png";